import React from 'react';
import WorkshopTable from './WorkshopTable';

const Workshop = () => {
    return (
        <>
            <WorkshopTable />
        </>
    );
};

export default Workshop;